require("./visualMapContinuous");

require("./visualMapPiecewise");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/visualMap.js
// module id = 2196
// module chunks = 1